import OffersList from './offersList'

export default OffersList
